import React from "react";

import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import { formateDate } from "beaktShared/helpers/masks";

export default function AvisoInauguracao({ avisos, onConfirmar, error, onRetry }) {
  if (error) {
    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div
            style={{
              background: '#f8d7da',
              border: '1px solid #f5c2c7',
              borderRadius: 4,
              padding: '12px 16px',
              marginBottom: 16,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: 8,
            }}
          >
            <span>
              <span role="img" aria-label="Erro" style={{ fontSize: 20, marginRight: 8 }}>⚠️</span>
              Não foi possível carregar os avisos de inauguração: {error}
            </span>
            {onRetry &&
              <Button
                size="sm"
                color="danger"
                onClick={onRetry}
                style={{ marginTop: 0, marginBottom: 0 }}
              >
                Tentar novamente
              </Button>
            }
          </div>
        </GridItem>
      </GridContainer>
    );
  }

  if (!avisos || avisos.length === 0)
    return null;

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <div
          style={{
            background: '#fff3cd',
            border: '1px solid #ffe69c',
            borderRadius: 4,
            padding: '12px 16px',
            marginBottom: 16,
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
            <span role="img" aria-label="Atenção" style={{ fontSize: 26, marginRight: 8 }}>⚠️</span>
            <strong style={{ fontSize: 18 }}>Avisos de Inauguração</strong>
          </div>
          {
            avisos.map(aviso => (
              <div
                key={aviso.estabelecimentoId}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: 8,
                  padding: '6px 0',
                  borderTop: '1px solid #ffe69c',
                }}
              >
                <span>
                  <strong>{aviso.nome}</strong> — inaugura em {aviso.diasRestantes} {aviso.diasRestantes === 1 ? 'dia' : 'dias'} ({formateDate(aviso.dtInauguracao)})
                </span>
                <Button
                  size="sm"
                  color="warning"
                  onClick={() => onConfirmar(aviso.estabelecimentoId)}
                  style={{ marginTop: 0, marginBottom: 0 }}
                >
                  Confirmar ciente
                </Button>
              </div>
            ))
          }
        </div>
      </GridItem>
    </GridContainer>
  );
}
